import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/apiAuth";

export const completeVotingAsync = createAsyncThunk(
  "completeVoting/completeVote",
  async ({ voteId, voteData }, { rejectWithValue }) => {
    try {
      if (!voteId) {
        throw new Error("Vote ID gerekli");
      }

      const response = await api.post(`/votes/complete/${voteId}`, voteData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.data) {
        throw new Error("Sunucudan geçersiz yanıt alındı");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          "Değerlendirme gönderilirken bir hata oluştu"
      );
    }
  }
);

export const fetchFeedbacksAsync = createAsyncThunk(
  "completeVoting/fetchFeedbacks",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/votes/feedbacks");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
